module.exports = __webpack_public_path__ + "img/airplane_blue.2f3b294e.png";